exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Styles used in create project,projectpageone,projectpagetwo and projectpagethree component */\n\n.group-header {\n    background: #e9ecef;\n    padding: 10px 5px;\n    margin: -1px -15px 5px -15px !important\n}\n\n.group-container {\n    border-style: solid;\n    border-width: 1px;\n    border-color: #ced4da;\n}\n\n.weblinktext {\n  -webkit-user-select: text; /* Chrome 49+ */ /* Firefox 43+ */ /* No support yet */\n  user-select: text;\n  word-wrap: break-word;\n}\n", ""]);

// exports
